var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import image from "@irati-web/recognition/src/images/reward-empty.png";
import styled from "styled-components";
import { greys } from "@irati/ui/src/global/colors";
import { Card } from "@irati/ui/src/Layout";
import { Para } from "@irati/ui/src/Labels";
var ICON_SIZE = 120;
export var RewardIcon = styled.img.attrs({
    alt: "reward",
    width: ICON_SIZE + "px",
    height: ICON_SIZE + "px",
    src: image
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 30px;\n  border-radius: 50%;\n  overflow:hidden;\n"], ["\n  margin-bottom: 30px;\n  border-radius: 50%;\n  overflow:hidden;\n"])));
export var Wrapper = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-shadow: none;\n  border: none;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-shadow: none;\n  border: none;\n"])));
export var Paragraph = styled(Para)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  max-width: 200px;\n  text-align: center;\n  margin-bottom: 30px;\n  color: ", ";\n"], ["\n  max-width: 200px;\n  text-align: center;\n  margin-bottom: 30px;\n  color: ", ";\n"])), greys.medium);
var templateObject_1, templateObject_2, templateObject_3;
